import React from "react";
import axiosUpload from "../../utils/axiosUpload";
import { isAxiosError } from "axios";
import axiosInstance from "../../utils/axiosInstance";

const useUploadDocument = () => {
  const [progress, progressSet] = React.useState(false);

  /**
   * Upload single file (image/document)
   * Internally uses multi-file uploader
   */
  const uploadImage = async (file: File) => {
    return uploadDocument([file], file.name);
  };

  /**
   * Upload single or multiple files
   */
  const uploadDocument = async (files: File[] | File | null, name: string) => {
    progressSet(true);

    try {
      const formData = new FormData();

      // Normalize to array
      if (files) {
        const fileArray = Array.isArray(files) ? files : [files];
        fileArray.forEach((file) => formData.append("files[]", file));
      }

      if (name) {
        formData.append("name", name);
      }

      const response = await axiosUpload.post("v1/upload", formData, {
        transformRequest: (formData) => formData,
      });

      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return error?.response?.data;
      }
      return false;
    } finally {
      progressSet(false);
    }
  };

  /**
   * Delete uploaded file
   */
  const deleteDocument = async (filePath: string) => {
    progressSet(true);

    try {
      const response = await axiosInstance.post("v1/destroy-upload", {
        path: filePath,
      });

      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return error?.response?.data;
      }
      return false;
    } finally {
      progressSet(false);
    }
  };

  return { progress, uploadDocument, uploadImage, deleteDocument };
};

export default useUploadDocument;
